import { ReactElement, useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCurrentUser } from '../../queries';
import {
  Button,
  ChevronLeft,
  CustomPageContainer,
  MyAccountIcon,
} from '@/components';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/Spinner';
import { TenantContext } from '@/components/TenantProvider';
import { MyAccountInfo } from './components';
import { LabelIcon } from '@/components/LabelIcon/LabelIcon';

export const UserProfilePage = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isLoadingTenantInfo } = useContext(TenantContext);

  const { data: user, isLoading: isLoadingUser } = useGetCurrentUser();

  const routeChange = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const isLoadingInfo = useMemo(
    () => isLoadingUser || isLoadingTenantInfo,
    [isLoadingUser, isLoadingTenantInfo],
  );

  return (
    <CustomPageContainer className="w-4/5">
      {isLoadingInfo ? (
        <Spinner className="ml-4 h-5 w-5" />
      ) : (
        <>
          <div className="flex justify-between">
            <div>
              <Button
                className="h-6 w-14 justify-between border-blueNuit p-2 font-black text-blueNuit"
                variant="outline"
                onClick={routeChange}
              >
                <ChevronLeft />
                {t('back')}
              </Button>
              <p className="mt-3 text-xs">
                {t('my_account')} /{' '}
                <span className="font-black">
                  {user?.firstName} {user?.lastName} {''}
                </span>
              </p>
            </div>
            <div>
              <LabelIcon
                label={t('my_account')}
                icon={<MyAccountIcon className="size-5 text-blueNuit" />}
              />
            </div>
          </div>
          <div className="flex w-full flex-col gap-10">
            <MyAccountInfo />
          </div>
        </>
      )}
    </CustomPageContainer>
  );
};
